import React, { useContext } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import isAbsoluteUrl from 'is-absolute-url';
import { LocaleContext } from '../i18n/LocaleContext';
import { locales, defaultLocale } from '../i18n/locales';

const Link = ({ to, ...props }) => {
  const { locale } = useContext(LocaleContext);

  if (isAbsoluteUrl(to)) {
    return (
      <a href={to} {...props}>
        {props.children}
      </a>
    );
  }

  // Auto-prepend locale prefix for internal links if not default locale
  let localizedTo = to;
  const config = locales[locale] || locales[defaultLocale];

  if (!config.isDefault && to.startsWith('/')) {
    // Check if link already has a locale prefix
    const hasLocalePrefix = Object.values(locales).some(
      l => !l.isDefault && l.slug && to.startsWith(`/${l.slug}/`)
    );
    // Also check if it's exactly the locale root
    const isLocaleRoot = Object.values(locales).some(
      l => !l.isDefault && l.slug && to === `/${l.slug}`
    );

    if (!hasLocalePrefix && !isLocaleRoot) {
      localizedTo = `/${config.slug}${to}`;
    }
  }

  return <GatsbyLink to={localizedTo} {...props} />;
};

export default Link;
